import { useContext } from 'react';
import { LoaderContext } from 'providers/LoaderProvider';

const useLoader = () => useContext(LoaderContext);

export default useLoader;
